import { Ownership } from "./ownership";

export class Law {
  public id: string;
  public name: string;
  public shortName: string;
  public fileId: string;
  public ownership: Ownership;
}
